import { createModal, Tooltip } from '@thermon-platforms/thermon-ui-core';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import Modal from './modal';

function Button({device, onClose}) {
  function openModal() {
    const modal = createModal(<Modal device={device} close={onClose} />);
    modal.open();
  }

  return (<>
    <button
      className="card-management"
      data-tooltip-content={t`Card Management`}
      data-tooltip-id="card-management-tooltip"
      onClick={openModal}
    >
      <Trans>Card Management</Trans>
    </button>
    <Tooltip id="card-management-tooltip" place="bottom-end" />
  </>)
}

export default Button;
